export default {"src":"/_next/static/media/preloader.d10c51f0.gif","height":1080,"width":1080,"blurWidth":0,"blurHeight":0};